import { Card, alpha, CardContent, Box, Typography } from "@mui/material";
import type { BenefitCardProps } from "./types/BenefitCardProps";

export function BenefitCard({ icon, title, description }: BenefitCardProps) {
  return (
    <Card
      sx={{
        height: "100%",
        textAlign: "center",
        borderRadius: 2,
        border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: (theme) => `0 16px 32px ${alpha(theme.palette.common.black, 0.1)}`,
        },
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
            color: "primary.main",
          }}
        >
          {icon}
        </Box>

        <Typography variant="h6" fontWeight={600} mb={1}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" lineHeight={1.6}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}
